var _rect, _rect2, _rect3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssessmentFail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 122,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 111.984,
    height: 111.984,
    x: 4.883,
    y: 4.883,
    fill: "#FFE9E9",
    rx: 55.992
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 85.48,
    height: 85.48,
    x: 18.137,
    y: 18.141,
    fill: "#FFB7B7",
    rx: 42.74
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 59.727,
    height: 59.727,
    x: 31.012,
    y: 31.016,
    fill: "#FF1A1A",
    rx: 29.863
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F8F8FA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m66.875 54.875-12 12m0-12 12 12"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentFail);
export default __webpack_public_path__ + "static/media/assessment-fail.6aa8b792e7532ac56784fca22d61ed56.svg";
export { ForwardRef as ReactComponent };